module.exports = "https://trybtryb-legacy.web.app/img/graduation-cap.d9e60ab1.svg";